import { ArrowUpRight } from "lucide-react";
import { Link } from "react-router";
import type { CommunityNote } from "../../../api/community";
import { MediaImage } from "../../../components/MediaImage";
import { Skeleton } from "../../../components/Skeleton";
import { thumbForNote } from "../../community/community-data";

type HomeCharacterSceneProps = {
  materialName: string;
  note: CommunityNote | undefined;
  loading: boolean;
};

/** 材质面板右下角浮动的真实应用场景：一件社区作品，点击进入社区详情。 */
export function HomeCharacterScene({ materialName, note, loading }: HomeCharacterSceneProps) {
  if (loading) {
    return (
      <div className="home-character-scene is-loading" aria-hidden="true">
        <span className="home-character-scene-media"><Skeleton className="is-fill" /></span>
      </div>
    );
  }
  if (!note) return null;
  const cover = thumbForNote(note);

  return (
    <Link
      className="home-character-scene"
      to={`/community/${note.id}`}
      aria-label={`真实应用：${note.title}，在社区查看这件${materialName}相关作品`}
    >
      <span className="home-character-scene-media">
        <MediaImage src={cover} alt={note.title} />
        <span className="home-character-scene-hover" aria-hidden="true">去社区看看</span>
      </span>
      <span className="home-character-scene-copy">
        <small>真实应用</small>
        <strong>{note.title}</strong>
      </span>
      <i aria-hidden="true"><ArrowUpRight size={16} strokeWidth={1.8} /></i>
    </Link>
  );
}
